import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../utils/config/config";

export const useModeration = () => {
  const [list, setList] = useState([]);
  const [stats, setStats] = useState({ total: 0, published: 0, pending: 0, drafts: 0, rejected: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const qs = new URLSearchParams();
      if (params.status && params.status !== "all") qs.set("status", params.status);
      if (params.search) qs.set("search", params.search);
      const [l, s] = await Promise.all([
        axiosInstance.get(`blog/admin?${qs.toString()}`),
        axiosInstance.get("blog/admin/stats"),
      ]);
      setList(l.data || []);
      setStats(s.data);
    } catch (e) {
      setList([]);
      setError(e?.response?.data?.message || "Failed to load moderation queue");
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const publish = useCallback((id) => axiosInstance.post(`blog/${id}/publish`), []);
  const reject = useCallback((id, comment) => axiosInstance.post(`blog/${id}/reject`, { comment }), []);
  const unpublish = useCallback(
    (id, comment) => axiosInstance.post(`blog/${id}/unpublish`, { comment }), []);
  const remove = useCallback((id) => axiosInstance.delete(`blog/${id}`), []);

  return { list, stats, loading, error, load, publish, reject, unpublish, remove };
};
